export const HEADERS = [
  "Site Id",
  "Site Count",
  "Participant Count",
  "Visit Count",
  "Assessment Count",
  "Visit Overhead",
  "Assessment Cost",
  "Exclude Cost",
  "Site Cost",
  "Total Cost",
];
